module.exports = __webpack_public_path__ + "img/back.35ccf14d.png";